import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/user.svg'


const _withScopeId = n => (_pushScopeId("data-v-6ccdba52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booster-nav" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "nav-width row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-4 col-lg-6 pt-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.booster.co.nz/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo",
      alt: "Booster",
      src: _imports_0
    })
  ])
], -1))
const _hoisted_5 = { class: "col-12 col-sm-12 col-md-8 col-lg-6 pt-1" }
const _hoisted_6 = { class: "row justify-content-end" }
const _hoisted_7 = { class: "col align-items-end text-right" }
const _hoisted_8 = { class: "col-auto ps-1 pe-0 d-none" }
const _hoisted_9 = {
  key: 0,
  class: "col-auto px-0"
}
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "dropdownMenuButton1",
  class: "btn",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "user-icon",
    src: _imports_1
  })
], -1))
const _hoisted_12 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "dropdown-item d-none",
    href: "#"
  }, "Change password")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClientSearch = _resolveComponent("ClientSearch")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ClientSearch)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.adviser,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.adviser) = $event)),
                options: [],
                placeholder: "👁 Advisers company",
                class: "rounded"
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("ul", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleLogout()))
                        }, "Logout")
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}